import React from "react";
import Chart from "react-apexcharts";

const DonutChart = ({
  scheduled,
  onTrack,
  completed,
  wont_be_done,
  delayed,
}) => {
  const options = {
    chart: {
      type: "pie",
    },
    labels: ["scheduled", "onTrack", "wont_be_done", "completed", "delayed"],
    series: [scheduled, onTrack, wont_be_done, completed, delayed],
    colors: ["#800080", "#008000", "#FF0000", "#0000FF", "#ffce08"],
    plotOptions: {
      pie: {
        dataLabels: {
          offset: -10,
        },
      },
    },

    // Ensure the fill colors are set

    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },

          legend: {
            show: false,
          },
          colors: ["#800080", "#008000", "#FF0000", "#0000FF", "#ffce08"],
        },
      },
    ],
  };

  return (
    <div>
      {/* <h3>Simple Donut Chart</h3> */}
      <Chart
        options={options}
        series={options.series}
        type="pie"
        width="350"
        // height="200"
      />
    </div>
  );
};

export default DonutChart;
